import { type SpendProductPurchaseDto } from 'entities/ReportSpendSummary';
import { toNumber } from 'shared/lib/number/number';
import { type ReportWidgetItem } from 'widgets/ComposableReportWidget';

export const mapProductPurchasesToWidgetItems = (
    purchases: SpendProductPurchaseDto[],
): ReportWidgetItem[] =>
    purchases.map((purchase, index): ReportWidgetItem => {
        const submittedDate = new Date(purchase.submittedAt);
        const dateLabel = new Intl.DateTimeFormat(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        }).format(submittedDate);

        return {
            id: `${purchase.order.id}-${purchase.supplierId}-${index}`,
            label: purchase.order.orderNumber ?? purchase.order.id,
            primaryValue: toNumber(purchase.spend),
            secondaryValues: {
                date: dateLabel,
                orderNumber: purchase.order.orderNumber ?? '',
                propertyName: purchase.propertyName ?? '',
                supplierName: purchase.supplierName,
                quantity: purchase.quantity,
                spend: purchase.spend,
            },
            meta: { orderId: purchase.order.id },
        };
    });
